export default "__VITE_ASSET__RMwwrsXC__"